import IntroStep1 from '/business/airbp/components/pages/landing/IntroStep1';
import IntroStep2 from '/business/airbp/components/pages/landing/IntroStep2';

export const landingPageIntroSteps = [
  { id: 'step1', component: <IntroStep1 /> },
  { id: 'step2', component: <IntroStep2 /> },
];
